import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    control: '',
    root: 'relative',
    content: 'flex flex-col overflow-hidden transition-max-height ease-in-out',
  },
  styles: {
    control: {},
    root: {},
    content: {},
  },
}));
